"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defaultTheme = _interopRequireDefault(require("../utils/defaultTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//import { useContext } from 'react';
//import { ThemeContext } from 'styled-components';
function usePalette() {
  return _defaultTheme["default"];
}

var _default = usePalette;
exports["default"] = _default;